import React from 'react';
import styled from 'styled-components';
import Text from '@airasia/phoenix-components/components/Text';
import { string, bool, func } from 'prop-types';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import { Row } from '..';

const OUT_OF_FIVE = '/5';

const ParentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 32px 0px 16px 0px;
  font-family: 'DM Sans';
  width: '100%';
`;

const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const RatingArea = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 39px;
`;

const UserRating = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  height: 40px;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  box-sizing: border-box;
  margin-right: 12px;
  background: #4b4fa6;
  border-radius: 12px 12px 0px 12px;
`;

const UserRatingMove = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 10px;
  height: 40px;
  color: #ffffff;
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
  box-sizing: border-box;
  margin-right: 12px;
  background: #023c40;
  border-radius: 12px 12px 0px 12px;
`;

const UserRatingTextArea = styled.div`
  height: 39px;
`;

const CountLabel = styled.div`
  height: 18px;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  margin-right: 4px;
  color: #75767a;
`;

const ReadReviewsLink = styled.div`
  height: 18px;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  margin-right: 4px;
  color: #4b4fa6;
  text-decoration: underline;
  cursor: pointer;
`;

const ReadReviewsLinkMove = styled.div`
  height: 18px;
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  margin-right: 4px;
  color: #8d1414;
  text-decoration: underline;
  cursor: pointer;
`;

const UserReviewOverview = ({
  isMobile,
  rating,
  countLabel,
  ratingLabel,
  readReviewsLabel,
  handleReadReviews,
  theme,
  move,
}) => {
  return (
    <PhoenixTheme theme={theme}>
      <ParentWrapper>
        <TopHeader>
          <RatingArea>
            {move ? (
              <UserRatingMove>{rating + OUT_OF_FIVE}</UserRatingMove>
            ) : (
              <UserRating>{rating + OUT_OF_FIVE}</UserRating>
            )}
            <div>
              <UserRatingTextArea>
                <Text
                  Theme={PhoenixTheme}
                  color="neutral"
                  type="normal"
                  bold
                  customProperties={{
                    fontWeight: 500,
                    lineHeight: '150%',
                    marginTop: '8px',
                  }}
                >
                  {ratingLabel}
                </Text>
                <Row>
                  <CountLabel isMobile={isMobile}> {countLabel} </CountLabel>
                  {theme === 'AIRASIA_MOVE' ? (
                    <ReadReviewsLinkMove onClick={handleReadReviews}>
                      {readReviewsLabel}
                    </ReadReviewsLinkMove>
                  ) : (
                    <ReadReviewsLink onClick={handleReadReviews}>
                      {readReviewsLabel}
                    </ReadReviewsLink>
                  )}
                </Row>
              </UserRatingTextArea>
            </div>
          </RatingArea>
        </TopHeader>
      </ParentWrapper>
    </PhoenixTheme>
  );
};

UserReviewOverview.propTypes = {
  isMobile: bool,
  rating: string,
  ratingLabel: string,
  countLabel: string,
  readReviewsLabel: string,
  handleReadReviews: func,
  theme: string,
  move: bool,
};

UserReviewOverview.defaultProps = {
  isMobile: false,
  rating: '',
  ratingLabel: '',
  countLabel: '',
  readReviewsLabel: 'Read reviews',
  handleReadReviews: () => {},
  theme: 'AIRASIA_CLASSIC',
  move: false,
};

export default UserReviewOverview;
